import './WorkflowHelp.scss';

import React, { FC, useState } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface WorkflowHelpProps {}

const WorkflowHelp: FC<WorkflowHelpProps> = () => {
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  
  return (
    <div className='form-text text-muted'>
      <div className='pull-right'>
        <button type="button" onClick={handleShow} className='btn btn-link text-sm'>
          Flowchart
        </button>
        &nbsp;|&nbsp;
        <a 
          className='btn btn-link text-sm'
          href="https://blabberjax.atlassian.net/wiki/spaces/BKP/pages/428146689/Document+Publishing+Workflow" 
          target="_blank"
          rel="noreferrer">
          Workflow help
        </a>
      </div>
      <Modal show={show} onHide={handleClose} className='modal-xl'>
        <Modal.Header closeButton>
          <Modal.Title>Document Publishing Workflow</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <a href="/document-status-workflow.png" target="_blank">
            <img src="/document-status-workflow.png" alt="document status workflow" className='img-fluid' />
          </a>
        </Modal.Body>
        <Modal.Footer>
          <a className='btn btn-link' href="https://blabberjax.atlassian.net/wiki/spaces/BKP/pages/428146689/Document+Publishing+Workflow" 
            target="_blank"
            rel="noreferrer">
            More workflow help
          </a>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default WorkflowHelp;
